module.exports = __webpack_public_path__ + "static/media/low_visibility_3.903810b2.png";